import { render, staticRenderFns } from "./Bulletin.vue?vue&type=template&id=874213a0&scoped=true&"
import script from "./Bulletin.js?vue&type=script&lang=js&"
export * from "./Bulletin.js?vue&type=script&lang=js&"
import style0 from "./Bulletin.vue?vue&type=style&index=0&id=874213a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874213a0",
  null
  
)

export default component.exports